import React, { useEffect,useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form } from 'antd';

import SelectOption from '../../common/SelectOption'
import InputField from '../../common/InputField'
import { emailValidation, nameValidation, numberRegexValidation, emptyValidation} from '../../../helper/FeildValidations'
import { clearSpaceDetails } from '../Spaces/SpaceAction';
import {updateSpaceOwnerDetails, filterSpaceName, fetchSpaceDetails} from './AssignSpaceAction'
import {COUNTRY_CODES} from '../../common/constants'
import AutoComplete from '../../common/AutoCompleteField'

const layout = {
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 16
    }
};

const AssignSpace = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const pageSize = 20;
    const spaces = useSelector(state => state?.assignspace?.filterSpaceName?.data || []);
    const spaceDetails = useSelector((state) => state.assignspace?.spaceDetails?.data || [])
    const [country, setCountry] = useState();

    const clearFields = () => {
        form.resetFields();
        setCountry(null)
    }

    useEffect(() => {
        dispatch(clearSpaceDetails());
    }, [])
    
    const handleCountrySelect =(country) => {
        setCountry(country);
    }

    const handleOnChange = (searchText) => {
        if(searchText && searchText.length > 2)
        dispatch(filterSpaceName(0, pageSize, searchText, country))
    }

    const handleOnSelect = (value, option) => {
        dispatch(fetchSpaceDetails(option.key))
    }

    useEffect(() => {
        form.setFieldsValue({
            spaceOwner: spaceDetails?.spaceOwner
        });
    }, [spaceDetails]);
    
    useEffect(() => {form.resetFields()}, []);

    const onFinish = values => {
        dispatch(updateSpaceOwnerDetails({
            ...values.spaceOwner,
            id: spaceDetails.id
        },
        spaceDetails.version, 
        clearFields));
    }

    return (
        <Form
            {...layout}
            form={form}
            onFinish={onFinish}
        >
            <h1 className="title">Assign Space</h1>
            <div className="basic-details-wrapper">
                <SelectOption
                    isMultiple={false}
                    name={['country']}
                    placeholder={'Country'}
                    label={'Country'}
                    values={COUNTRY_CODES}
                    handleOnSelect={handleCountrySelect }
                    labelName={'label'}
                    valueName={'name'}
                />
                {country && 
                <>
                    <AutoComplete
                        label={'Space'}
                        name={'Space'}
                        placeHolder={'Type and select Space name'}
                        options={spaces}
                        rules={emptyValidation}
                        handleOnChange={handleOnChange}
                        handleOnSelect={handleOnSelect}
                        labelName={'spaceName'}
                        valueName={'spaceName' }
                    />
                    <InputField
                        name={['spaceOwner','firstName']}
                        label={'First Name'}
                        rules={nameValidation}
                    />
                    <InputField
                        name={['spaceOwner','lastName']}
                        label={'Last Name'}
                        rules={nameValidation}
                    />
                    <InputField
                        name={['spaceOwner','email']}
                        label={'Email Address'}
                        rules={emailValidation}
                    />
                    <InputField
                        name={['spaceOwner','phoneNumbers', 0]}
                        label={'Number'}
                        rules={numberRegexValidation}
                    />
                    <SelectOption
                        isMultiple={false}
                        name={['spaceOwner','country']}
                        placeholder={'Country Code'}
                        rules={emptyValidation}
                        label={'Country Code'}
                        values={COUNTRY_CODES}
                        handleOnSelect={null}
                        labelName={'label'}
                        valueName={'name'} 
                    />
                    <div className="btn-wrapper"> 
                        <Button 
                            className="submit-btn" 
                            type="primary" 
                            htmlType="submit" 
                        >Submit</Button>
                    </div> 
                </>}
            </div>
        </Form>
    )
}

export default AssignSpace;